import Mgr from "@/services/SecurityService";

let mgr = new Mgr();

export default function(to, from, next) {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    if (to.meta.role)
      mgr.getRole().then(
        sucess => {
          if (sucess.includes(to.meta.role)) {
            next();
          } else {
            next("/unauthorized");
          }
        },
        err => {
          console.log(err);
        }
      );
    next();
  } else {
    next();
  }
}
